import {useRef} from "react"
import Text from "../../components/input/text";
import Textarea from "../../components/input/textarea";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {role_info} from "../../config/tips";
import Select from "../../components/input/select";


const Form = (props) => {
    const {role, permissions, errors, isReady, onSubmit} = props
    const formRef = useRef()


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            name          : FormData.get('name'),
            description   : FormData.get('description'),
            id_permissions: FormData.getAll('id_permissions'),
        })
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>

            <Alert
                icon="info"
                docsPath="/docs/roles"
                message={role_info}
            />

            <Text required
                size="md"
                name="name"
                label="Name"
                isReady={isReady}
                error={errors && errors?.name}
                value={role?.name}
                placeholder="Type role name..."
            />

            <Textarea
                required
                size="md"
                name="description"
                label="Description"
                isReady={isReady}
                error={errors && errors?.description}
                value={role?.description}
                placeholder="Type role description..."
            />

            <Select
                required
                size="md"
                isMulti={true}
                isReady={isReady}
                label="Permissions"
                name="id_permissions"
                options={permissions}
                closeMenuOnSelect={false}
                isClearable={true}
                value={role?.id_permissions}
                error={errors && errors?.id_permissions}
                placeholder="Choose permissions"
            />

            <Button
                size="sm"
                color="primary"
                isReady={isReady}
                icon={role ? 'check' : 'plus'}
                label={role ? 'Update' : 'Create'}
            />

        </form>
    )
}

export default Form